import { render, staticRenderFns } from "./OnceCode.vue?vue&type=template&id=4bb77c65&scoped=true&"
import script from "./OnceCode.vue?vue&type=script&lang=js&"
export * from "./OnceCode.vue?vue&type=script&lang=js&"
import style0 from "./OnceCode.vue?vue&type=style&index=0&id=4bb77c65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb77c65",
  null
  
)

export default component.exports